import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../prop-types';
import CustomerUser from '../../../models/CustomerUser';
import Price from '../../product/Price';
import PropTypes from 'prop-types';
import BalanceUser from '../../../models/BalanceUser';

@observer
export class UserInfo extends Component {
  renderActiveStatus = () => {
    const { user } = this.props;

    return user.is_active ? (
      <div className="UserInfo__status-active">
        <FormattedMessage
          id="userInfo.active"
          defaultMessage="Username is active"
        />
      </div>
    ) : (
      <div className="UserInfo__status-passive">
        <FormattedMessage
          id="userInfo.notInUse"
          defaultMessage="Username is not active"
        />
      </div>
    );
  };

  render() {
    const { user, showBalance } = this.props;

    return (
      <div className="UserInfo">
        <div>
          {user.firstname} {user.lastname}
        </div>
        {user.login_name && <div>{user.login_name}</div>}
        {user.email && <div>{user.email}</div>}
        {user.telephone && <div>{user.telephone}</div>}
        {showBalance && user.account_balance && (
          <Price price={user.account_balance} />
        )}
        {this.renderActiveStatus()}
      </div>
    );
  }
}

UserInfo.propTypes = {
  user: PropTypes.oneOfType([
    modelOf(CustomerUser).isRequired,
    modelOf(BalanceUser).isRequired,
  ]),
  showBalance: PropTypes.bool,
};

export default UserInfo;
